import reset from './reset';

export default {
  reset
};



// WEBPACK FOOTER //
// ./src/app/services/password/index.js